var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"content is-size-7 p-md"},[_c('h1',{staticClass:"has-text-white is-size-3 m-b-md"},[_vm._v(_vm._s(_vm.$t('Games in category'))+" "+_vm._s(_vm.$t(_vm.tag)))]),_vm._v(" "),_c('GameTileList',{attrs:{"games":_vm.games}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b9892b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangGG/TagPage.vue
// module id = null
// module chunks = 